import { bl_tpy_innovatif_user_hdr_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class InnovatifUserHdrContainerModel extends BaseContainerModel {
    bl_tpy_innovatif_user_hdr: bl_tpy_innovatif_user_hdr_RowClass = new bl_tpy_innovatif_user_hdr_RowClass();
}
